// ============================================
// Typing Indicator Component
// Shows who is currently typing
// ============================================

import React from 'react';
import { useChat } from './ChatProvider';

/**
 * Display typing indicator with user names
 */
const TypingIndicator = () => {
  const { typingUsers, currentUser } = useChat();

  // Filter out current user from typing list
  const otherTypingUsers = typingUsers.filter(
    user => !(currentUser && user.id === currentUser.id && user.type === currentUser.type)
  );

  if (otherTypingUsers.length === 0) {
    return null;
  }

  // Build typing text
  const getTypingText = () => {
    if (otherTypingUsers.length === 1) {
      return `${otherTypingUsers[0].name || 'Someone'} is typing`;
    } else if (otherTypingUsers.length === 2) {
      return `${otherTypingUsers[0].name || 'Someone'} and ${otherTypingUsers[1].name || 'someone'} are typing`;
    } else {
      return `${otherTypingUsers.length} people are typing`;
    }
  };

  return (
    <div className="px-4 py-1.5 bg-gray-50 border-t border-gray-100">
      <div className="flex items-center space-x-2 text-xs text-gray-500">
        {/* Animated dots */}
        <div className="flex space-x-1">
          <span className="w-1.5 h-1.5 bg-gray-400 rounded-full animate-bounce" style={{ animationDelay: '0ms' }}></span>
          <span className="w-1.5 h-1.5 bg-gray-400 rounded-full animate-bounce" style={{ animationDelay: '150ms' }}></span>
          <span className="w-1.5 h-1.5 bg-gray-400 rounded-full animate-bounce" style={{ animationDelay: '300ms' }}></span>
        </div>
        <span>{getTypingText()}</span>
      </div>
    </div>
  );
};

export default TypingIndicator;
